import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import CreateticketButtonSection from "./CreateTicketButtonSection";
import useHttpHook from "../../../../Hooks/HttpHook";
import TicketTypeList from "./TicketTypeList";
import SubmitButtonGroup from "../../../UiElement/FormElement/SubmitBtnGroup";
import { EventById, deleteTicketApi } from "../../../../utils/ApiConstant";
import { updEventData } from "../../../../ReduxSlice/Event/eventSlice";
import TicketForm from "./TicketForm";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../../utils/notify";
const Tickets = (props) => {
  const [loading, sendRequest, error, successmessage] = useHttpHook();
  const dispatch = useDispatch();
  const eventData = useSelector((state) => state.event);
  console.log(eventData, "-------------eventData-");
  const { eventId } = useParams();
  const [showTicketForm, setShowTicketForm] = useState(false);
  const [TicketTypeData, setTicketTypeData] = useState();
  let navigate = useNavigate();
  const location = useLocation();
  const openCreateTicketForm = () => {
    setTicketTypeData(undefined);
    setShowTicketForm(true);
  };

  useEffect(() => {
    if ((props.createTicketRequest || 0) > 0) {
      openCreateTicketForm();
    }
  }, [props.createTicketRequest]);

  const editTicket = (TicketTypeData) => {
    setTicketTypeData(TicketTypeData);
    setShowTicketForm(true);
  };
  const deleteTicketHalndler = async (TicketTypeData) => {
    console.log(TicketTypeData);
    let event = await sendRequest(deleteTicketApi + eventId, {
      method: "delete",
      data: { _id: TicketTypeData._id },
    });
    dispatch(updEventData(event));
  };
  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  useEffect(() => {
    getEventData();
  }, []);
  const getEventData = async () => {
    let event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
    //showingFormData(event)
  };
  return (
    <MainComponentWrapper
      Loading={loading}
      errorInfo={error}
      successMsg={successmessage}
    >
      <div className="evntFormUI">
        {eventData.status && eventData.data.ticketType.length == 0 && (
          <CreateticketButtonSection
            isLoading={loading}
            ButtonClickHandler={openCreateTicketForm}
          />
        )}
        {eventData.status && eventData.data.ticketType.length > 0 && (
          <TicketTypeList
            event={eventData}
            ShowForm={editTicket}
            deleteTicket={deleteTicketHalndler}
            isLoading={loading}
          />
        )}
        <TicketForm
          OpenTicketForm={showTicketForm}
          CloseModal={() => {
            setShowTicketForm(false);
            setTicketTypeData(undefined);
          }}
          TicketData={TicketTypeData}
          eventData={eventData}
        />
        {eventData.data.ticketType?.length > 0 &&
          (location?.state?.isOnlyTicket === false ||
            location.state === null ||
            Object.keys(location.state).length === 0) && (
            <SubmitButtonGroup
              clickHandler={() => {
                navigate(`/myEvents/${eventId}/settings`, { replace: true });
              }}
              isLoading={loading}
              GroupClassName="event-tickets-footer"
            />
          )}
      </div>
    </MainComponentWrapper>
  );
};
export default Tickets;
